module.exports = __webpack_public_path__ + "static/webviewmobile-6fd4cfa9d3268b11a5c59c109407b042.png";